import React from 'react';
import RepairOrdersPage from './RepairOrdersPage';

function CustomerReturnsPage() {
  return (
    <RepairOrdersPage
      pageTitle="Customer Returns"
      newTabLabel="New Return"
      listTabLabel="Customer Returns"
      singularLabel="Customer Return"
      pluralLabel="customer returns"
      listEndpoint="/transfers/customer-returns"
      listPrimaryColumnLabel="Credit Memo #"
      listWarrantyColumnLabel="Items"
      allowListSelection={false}
      listDocumentTransactionTypeId={10}
      customerReturnMode
    />
  );
}

export default CustomerReturnsPage;
